import { Items } from './common';

export interface Payment {
    id: number;
    amount: number;
    created_at: string;
    payment_fee: number | null;
    payment_system: {
        id: number;
        name: string;
        logo: string;
    };
    payment_type: 'deposit' | 'withdraw';
    status: number;
}

export type PaymentItems = Items<Payment>;

export interface DepositLinkData {
    amount: number;
    fee_amount: number;
    payment_id: number;
    first_deposit_bonus_enabled: boolean;
}

export interface CashoutLinkData {
    amount: number;
    fee_amount: number;
    payment_id: number;
}

export enum CashoutStatus {
    PROCESSING = 0,
    PROCESSED = 1,
    PROCESSED_WITH_FEE = 2,
    REJECTED = 3,
    MANUALLY = 4
}

export interface CashoutLinkResponse {
    status: CashoutStatus;
    transaction_id: string;
    url: string | null;
}

export interface ClientRequiredField {
    required: boolean;
    input_type: string;
    description: string;
}

export interface AutopayoutThreshold {
    period: 'per_transaction' | 'per_day' | 'per_week' | 'per_month';
}

export interface CurrenciesSettings {
    [currencyCode: string]: number;
}

export interface PaymentGateway {
    id: number;
    name: string;
    logo: string;
    description: string;
    autopayout: boolean;
    codename: string;
    created_at: string;
    currencies: string[];
    fee: string;
    fix: string;
    icon: string | null;
    is_active: boolean;
    limit: number;
    payment_max_limit: number;
    payment_min_limit: number;
    type: 'WITHDRAW' | 'DEPOSIT';
    payment_methods: ['test', 'card', 'crypto', 'alipay'];
    autopayout_threshold: {
        currencies_settings: CurrenciesSettings;
        period: AutopayoutThreshold;
    };
    client_required_fields: Record<string, ClientRequiredField> | Record<string, never>;
}

export type PaymentMethod = Omit<PaymentGateway, 'payment_methods' | 'codename'>;

export interface GroupedPaymentMethod {
    codename: string;
    payment_methods: PaymentMethod[];
}

export interface CalculateFeeData {
    amount: number;
    payment_system_id: number;
}

export interface CalculateFeeResponse {
    amount: number;
    fee_amount: number;
    payment_system_id: number;
    total_amount: number;
}

export interface Compensation {
    id: number;
    amount: number;
    reason: string;
    created_at: string;
}

export interface QuickDepositPresets {
    quick_deposit_presets: {
        [key: string]: number[];
    };
}

export type QuickDepositPreset = {
    value: string;
}[];

export type CompensationItems = Items<Compensation>;
